import {
  Component,
  ElementRef,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatSelectChange } from "@angular/material/select";
import { IWayPoint } from '../../itinenary-list/itinerary';
import { FileDataService } from "../../services/file-data.service";
import { MapDataService } from "../../services/map-data.service";


@Component({
  selector: "app-map-search",
  templateUrl: "./map-search.component.html"
})
export class MapSearchComponent {
  @ViewChild("searchRef") searchTextInput: ElementRef;
  @Output() sendMarkerData = new EventEmitter<any>();

  // Map Search related
  searchInput = new FormControl("");
  filteredOptions: IWayPoint[];

  constructor(private mapService: MapDataService,
              private fileService:FileDataService  ) {}

  displayFn(searchItem: any): string {
    return searchItem && searchItem.itineraryName
      ? searchItem.itineraryName
      : "";
  }
  
  
  filterSearch(name: string) {
    
    this.fileService.writeLog("filterSearch-start").subscribe((data:any)=>{

    })
    this.mapService.getMapSearchData(name).subscribe(
      (res: any) => {
        if (res.responseStatus === "Success") {
          this.filteredOptions = res.responseData;
          this.fileService.writeLog("filterSearch-end").subscribe((data:any)=>{

          })
        }
      },
      (_: any) => {
        this.filteredOptions = [];
      }
    );
    this.searchInput.valueChanges.subscribe((searchValue: string) => {
      if (searchValue === "") {
        this.filteredOptions = [];
      }
    });
  }
  onSearchSelect(option: MatSelectChange) {
    this.fileService.writeLog("onSearchSelect-start").subscribe((data:any)=>{

    })
    this.searchTextInput.nativeElement.blur();
    this.sendMarkerData.emit(option.value);
    this.fileService.writeLog("onSearchSelect-end").subscribe((data:any)=>{

    })
  }
}
